"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newInvokeIosV1 = exports.getCallbackNameV1 = void 0;

require("core-js/modules/es.regexp.exec.js");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _utils = require("./utils");

function andrExecuteV1(action, param) {
  (0, _utils.logInfo)('sdk----------------------sdk');
  (0, _utils.logInfo)('andr接口请求');
  (0, _utils.logInfo)('param:' + JSON.stringify(param));
  (0, _utils.logInfo)('action:' + action);
  (0, _utils.logInfo)('sdk----------------------sdk');

  try {
    if (window.zhuanzhuanMApplication) {
      var oriParam = JSON.stringify(param);
      window.zhuanzhuanMApplication.executeCmd(action, oriParam);
    }
  } catch (error) {
    throw new Error(error + window.zhuanzhuanMApplication + (0, _typeof2.default)(window.zhuanzhuanMApplication.executeCmd) + window.zhuanzhuanMApplication.executeCmd);
  }
}
/**
 * iosNewExecute(
 * @description 调用ios 外放的接口call 发送参数
 * @ignore
 */


function iosNewExecuteV1(action, param) {
  (0, _utils.logInfo)('sdk----------------------sdk');
  (0, _utils.logInfo)('ios接口请求');
  (0, _utils.logInfo)('param:' + JSON.stringify(param));
  (0, _utils.logInfo)('action:' + action);
  (0, _utils.logInfo)('sdk----------------------sdk');

  try {
    if (window.zhuanzhuanMApplicationIos) {
      var oriParam = JSON.stringify(param);
      window.zhuanzhuanMApplicationIos.call(action, oriParam);
    }
  } catch (error) {
    throw new Error(error + window.zhuanzhuanMApplicationIos + (0, _typeof2.default)(window.zhuanzhuanMApplicationIos.call) + window.zhuanzhuanMApplicationIos.call);
  }
}
/**
 * 封装回调函数，放入全局中
 * @ignore
 */


function actualCallbackV1(callback, del, name) {
  var callbackName = 'zzcallbackV1_' + (0, _utils.uniqId)() + '_' + name;

  try {
    var callbackFun = function callbackFun(state, res) {
      try {
        (0, _utils.logInfo)('客户端返回的state', state, '返回的数据', res);

        switch (state) {
          case '0':
            res = /^\{.*\}$/.test(res) ? JSON.parse(res) : res;
            callback(res, '', '0');
            break;

          case '-1':
            callback('', '此版本没有这个方法', '-1');
            (0, _utils.logInfo)('此版本没有这个方法, 升级版本看精彩内容哦~');
            break;

          case '-2':
            if (process.env.NODE_ENV !== 'production') {
              alert('入参格式错误');
            }

            callback('', '入参格式错误', '-2');
            break;

          default:
            callback('', '没有匹配到state', '-3');
            break;
        }

        if (del && window != window.top) delete window.top[callbackName];
      } catch (error) {
        (0, _utils.logWarn)('解析发生错误', error);

        try {
          window['@zz-common/zz-jssdk'].default.sendLegoTrace({
            pageType: '',
            mPage: '',
            actionType: 'feCallbackParseJsonError',
            dataMap: {
              api: '',
              paramJson: res
            }
          });
        } catch (error) {
          (0, _utils.logWarn)(error);
        }

        callback(res, '解析发生错误', '-5');
      }
    };

    window[callbackName] = callbackFun;
    if (window != parent.top) window.top[callbackName] = callbackFun;
  } catch (error) {
    callback('', error, '-4');
  }

  return callbackName;
}

var getCallbackNameV1 = function getCallbackNameV1(callback) {
  var del = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var name = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _utils.isFunction)(callback) ? actualCallbackV1(callback, del, name) : '';
};

exports.getCallbackNameV1 = getCallbackNameV1;

var newInvokeIosV1 = function newInvokeIosV1(action, param, callback) {
  param['callback'] = callback;
  if (_utils.isIOS) iosNewExecuteV1(action, param);
  if (_utils.isAndroid) andrExecuteV1(action, param);
};

exports.newInvokeIosV1 = newInvokeIosV1;